import Service, { getCallApiFunction } from '../service'
type ParamsType = {
  data: {
    roomId: string
  }
}
type ResponseType = {
  isSuccess: boolean
  roomId: string[]
}
class DeleteFavoriteRoomApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.config = {
      url: '/v1/livemall/member/favorite',
      method: 'DELETE',
      data: params.data,
    }
  }
}
export const deleteFavoriteRoom = async (params: ParamsType): Promise<ResponseType> => getCallApiFunction(new DeleteFavoriteRoomApi(params))
